import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PADDING_PROP_TYPES, MARGIN_PROP_TYPES } from './constants';
import generateClassModifiers from '../../helpers/generate-class-modifiers';

const defaultBreakpoints = {};

const Box = ({ children, breakpoints = defaultBreakpoints, ...spaces }) => {
  const spacesClasses = generateClassModifiers('ws-ui-box', spaces);
  const breakpointsSpacesClasses =
    breakpoints &&
    Object.keys(breakpoints).map((key) =>
      generateClassModifiers('ws-ui-box', breakpoints[key], key)
    );

  const classes = classNames('ws-ui-box', spacesClasses, breakpointsSpacesClasses);

  return <div className={classes}>{children}</div>;
};

Box.propTypes = {
  ...PADDING_PROP_TYPES,
  ...MARGIN_PROP_TYPES,
  breakpoints: PropTypes.shape({
    xs: PropTypes.shape({ ...PADDING_PROP_TYPES, ...MARGIN_PROP_TYPES }),
    sm: PropTypes.shape({ ...PADDING_PROP_TYPES, ...MARGIN_PROP_TYPES }),
    md: PropTypes.shape({ ...PADDING_PROP_TYPES, ...MARGIN_PROP_TYPES }),
    lg: PropTypes.shape({ ...PADDING_PROP_TYPES, ...MARGIN_PROP_TYPES }),
    xl: PropTypes.shape({ ...PADDING_PROP_TYPES, ...MARGIN_PROP_TYPES }),
    xxl: PropTypes.shape({ ...PADDING_PROP_TYPES, ...MARGIN_PROP_TYPES }),
  }),
  children: PropTypes.node.isRequired,
};

export default Box;
